/**
 * 認證相關工具函式
 */

/**
 * 智能判斷適當的登入頁面路徑
 * 根據當前路由和用戶角色判斷應該導向前台還是後台登入
 */
export function getAppropriateLoginPath(): string {
  const currentPath = window.location.pathname
  
  // 優先使用當前路由判斷
  if (currentPath.startsWith('/admin')) {
    return '/admin/login'
  }
  
  // 備用：使用用戶角色判斷
  const userStr = localStorage.getItem('auth_user')
  if (userStr) {
    try {
      const user = JSON.parse(userStr)
      const role = user.role
      
      // 後台角色導向後台登入
      if (['super_admin', 'super_admin_co', 'channel_admin', 'vendor', 'vendor_co'].includes(role)) {
        return '/admin/login'
      }
    } catch (error) {
      // 解析失敗，忽略錯誤
    }
  }
  
  // 預設前台登入
  return '/login'
}

/**
 * 清除認證資料
 */
export function clearAuthData(): void {
  localStorage.removeItem('auth_token')
  localStorage.removeItem('auth_user')
}

/**
 * 檢查是否為認證相關錯誤
 */
export function isAuthError(errorCode?: string): boolean {
  // 檢查全域標誌
  if ((window as any).__PLATFORM_AUTH_EXPIRED__) {
    return true
  }
  
  return errorCode === 'PLATFORM_AUTH_EXPIRED' || errorCode?.includes('AUTH') || false
}